<template>
	<div class="row centered">
		<AppTable ref="transactions-table"
			v-if="userStore.currBusinessId"
			:fetch-function="fetchFunction"
			:filters="filters"
			:table-headings="tableHeadings"
			:title="getString('card_transactions')"
			:total-items="cardsStore.cardTransactionsTableTotal || 0"
			:items="cardsStore.cardTransactionsTable || []"
			initial-sort-field="date"
			initial-sort-dir="DESC"
			@failed-fetch="details=>{$emit('failed-fetch', details)}" >

			<template #receipt="{item}">
				<TransactionReceiptButton :item="item" />
			</template>

		</AppTable>
	</div>
</template>

<script>
import AppTable from "@/shared/components/AppTable.vue";
import TransactionReceiptButton from "@/console-new/components/config/administration/cards/TransactionReceiptButton.vue";
import {useCardsStore, useUserStore} from "@/console-new/stores";
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const userStore = useUserStore();
		const cardsStore = useCardsStore();
		const languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		return {userStore, cardsStore, getString: languageStore.getString, currencyStore}
	},
	name: "CardsTransactionsTable",
	emits: ["failed-fetch"],
	components: {AppTable, TransactionReceiptButton},
	props: {
		cardId: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'cards_authorizations', // Use one of the table names
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "price",
					key: "amount",
					text: this.getString('amount'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 2,
					sortable: true,
					fieldName: 'date'
				},
				{
					text: this.getString('amount'),
					cols: 2,
					sortable: true,
					fieldName: 'amount',
					formatter: amount => this.currencyStore.readableCurrencyValue(amount, true, true, false)
				},
				{
					text: this.getString('merchant_name'),
					cols: 2,
					fieldName: 'merchant_name'
				},
				{
					text: this.getString('status'),
					cols: 2,
					fieldName: 'display_status',
					formatter: status => {
						const statusMap = {
							'pending': this.getString('pending'),
							'processed': this.getString('processed'),
							'refunded': this.getString('refunded')
						};
						return statusMap[status] || status;
					}
				},
				{
					text: this.getString('transaction_receipt'),
					cols: 2,
					fieldName: 'receipt_file',
					slotName: 'receipt',
				},
			]
		}
	},
	computed: {
		fetchFunction(filters, callback) {
			// Always use the same function, just pass cardId (which can be null)
			return (filters, callback) => {
				this.cardsStore.getFilteredCardTransactions(this.userStore.currBusinessId, this.cardId, filters, callback);
			};
		}
	},
	mounted() {
		// Add card name column if we're showing transactions for all cards
		if (this.cardId === null) {
			this.tableHeadings.splice(1, 0, {
				text: this.getString('card'),
				cols: 2,
				fieldName: 'card_name',
			});
		}
	},
	watch: {
		cardId(newVal, oldVal) {
			if (newVal !== oldVal) {
				if(this.$refs['transactions-table']) {
					this.$refs['transactions-table'].fetchData();
				}
			}
		},
		'cardsStore.forceRefresh': {
			handler() {
				if(this.$refs['transactions-table']) {
					this.$refs['transactions-table'].fetchData();
				}
			}
		}
	},
}
</script>

<style scoped lang="scss">

</style>